import React, { useState } from 'react'
const AddJD = () => {
      const [jobDescriptions, setJobDescriptions] = useState([]);
      const [jdForm, setJdForm] = useState({
        title: '',
        description: '',
        image: null,
        imagePreview: '',
        pdfPath: null,
        location: '',
        type: 'Full-time',
        responsibilities: [''],
        requirements: [''],
        contactEmail: '',
        vacancy: '',
      });
      const [showNotification, setShowNotification] = useState(false);
      const [notificationMessage, setNotificationMessage] = useState('');      
    
      const handleJDChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
          const file = files[0];
          setJdForm(prev => ({
            ...prev,
            image: file,
            imagePreview: URL.createObjectURL(file),
          }));
        } else if (name === 'pdfPath') {
          setJdForm(prev => ({ ...prev, pdfPath: files[0] }));
        } else {
          setJdForm(prev => ({ ...prev, [name]: value }));
        }
      };
    
      const handleArrayChange = (index, field, value) => {
        const updatedArray = [...jdForm[field]];
        updatedArray[index] = value;
        setJdForm(prev => ({ ...prev, [field]: updatedArray }));
      };
      
      const addArrayItem = (field) => {
        setJdForm(prev => ({ ...prev, [field]: [...prev[field], ''] }));
      };
      
      const removeArrayItem = (index, field) => {
        const updatedArray = [...jdForm[field]];
        updatedArray.splice(index, 1);
        setJdForm(prev => ({ ...prev, [field]: updatedArray }));
      };   
    
      const handleAddJD = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        
        formData.append('title', jdForm.title);
        formData.append('description', jdForm.description);
        formData.append('location', jdForm.location);
        formData.append('type', jdForm.type);
        formData.append('contactEmail', jdForm.contactEmail);
        formData.append('vacancy', jdForm.vacancy);
        formData.append('responsibilities', JSON.stringify(jdForm.responsibilities));
        formData.append('requirements', JSON.stringify(jdForm.requirements));
      
        console.log('Form Data:', formData); // Debugging line to check form data
        console.log('jdFormTitle:', jdForm.title); // Debugging line to check jdForm state
        // Append files if available
        if (jdForm.image) {
          formData.append('image', jdForm.image);
        }
        if (jdForm.pdfPath) {
          formData.append('pdfPath', jdForm.pdfPath);
        }
      
        try {
          const response = await fetch('/api/add-jd', {
            method: 'POST',
            body: formData,
          });
      
          if (!response.ok) {
            // If response is not okay, log the status and return
            const errorText = await response.text();
            console.error('Error response:', errorText);
            alert('Failed to add Job Description. Please try again later.');
            return;
          }
      
          const result = await response.json();
          
          if (result.success) {
            showNotificationAlert('Job Description added successfully!');
            
            // Update job descriptions locally (without needing the Base64 conversion)
            const newJD = {
              id: jobDescriptions.length + 1,
              ...jdForm,
              image: jdForm.image ? jdForm.image.name : '', // Just save the file name or path
              pdfPath: jdForm.pdfPath ? jdForm.pdfPath.name : '', // Similarly, save the file name or path
              date: new Date().toLocaleDateString(),
            };
            setJobDescriptions([...jobDescriptions, newJD]);
      
            // Reset form
            setJdForm({
              title: '',
              description: '',
              image: null,
              imagePreview: '',
              pdfPath: null,
              location: '',
              type: 'Full-time',
              responsibilities: [''],
              requirements: [''],
              contactEmail: '',
              vacancy: '',
            });
          } else {
            console.error('Server response indicates failure:', result);
            alert('Failed to add Job Description. Please check the input and try again.');
          }
        } catch (error) {
          console.error('Error during fetch:', error);
          alert('An error occurred while adding the job description. Please try again later.');
        }
      };
      
      
    
      const showNotificationAlert = (message) => {
        setNotificationMessage(message);
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      };
    
      
  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden p-8">
    <div className="px-6 py-5 border-b border-gray-200">
      <h3 className="text-2xl font-bold text-gray-900">Add Job Description</h3>
      <p className="mt-1 text-sm text-gray-600">Upload job details, responsibilities, requirements, and media.</p>
    </div>
  
    <form onSubmit={handleAddJD} className="p-6 space-y-8">
      <div className="grid grid-cols-1 gap-y-6 gap-x-6 sm:grid-cols-6">
        {/* Title */}
        <div className="sm:col-span-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Job Title</label>
          <input
            type="text"
            name="title"
            value={jdForm.title}
            onChange={handleJDChange}
            required
            placeholder="Enter job title"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
  
        {/* Description */}
        <div className="sm:col-span-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
          <textarea
            name="description"
            rows="4"
            value={jdForm.description}
            onChange={handleJDChange}
            required
            placeholder="Describe the job position"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          ></textarea>
        </div>
  
        {/* Two columns layout */}
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
          <input
            type="text"
            name="location"
            value={jdForm.location}
            onChange={handleJDChange}
            required
            placeholder="City, State or Remote"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
  
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Job Type</label>
          <select
            name="type"
            value={jdForm.type}
            onChange={handleJDChange}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">Select job type</option>
            <option>Full-time</option>
            <option>Part-time</option>
            <option>Contract</option>
            <option>Freelance</option>
            <option>Internship</option>
          </select>
        </div>
  
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
          <input
            type="email"
            name="contactEmail"
            value={jdForm.contactEmail}
            onChange={handleJDChange}
            required
            placeholder="contact@company.com"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
  
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Vacancy</label>
          <input
            type="text"
            name="vacancy"
            value={jdForm.vacancy}
            onChange={handleJDChange}
            required
            placeholder="Number of openings"
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
  
        {/* Media uploads section */}
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Upload Image</label>
          <div className="flex items-center justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
            <div className="space-y-1 text-center">
              <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <div className="flex text-sm text-gray-600">
                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                  <span>Upload an image</span>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleJDChange}
                    className="sr-only"
                  />
                </label>
                <p className="pl-1">or drag and drop</p>
              </div>
              <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
            </div>
          </div>
          {jdForm.imagePreview && (
            <div className="mt-2">
              <img src={jdForm.imagePreview} alt="Preview" className="w-32 h-20 object-cover rounded border border-gray-300" />
            </div>
          )}
        </div>
  
        <div className="sm:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Upload PDF</label>
          <div className="flex items-center justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
            <div className="space-y-1 text-center">
              <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              <div className="flex text-sm text-gray-600">
                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                  <span>Upload a PDF</span>
                  <input
                    type="file"
                    name="pdfPath"
                    accept="application/pdf"
                    onChange={handleJDChange}
                    className="sr-only"
                  />
                </label>
                <p className="pl-1">or drag and drop</p>
              </div>
              <p className="text-xs text-gray-500">PDF up to 10MB</p>
            </div>
          </div>
          {jdForm.pdfPath && (
            <div className="mt-2 text-sm text-gray-600 flex items-center">
              <svg className="w-4 h-4 mr-1 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
              </svg>
              {jdForm.pdfPath.name}
            </div>
          )}
        </div>
  
        {/* Responsibilities */}
        <div className="sm:col-span-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Responsibilities</label>
          <div className="space-y-2">
            {jdForm.responsibilities.map((item, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <input
                  type="text"
                  value={item}
                  onChange={(e) => handleArrayChange(idx, 'responsibilities', e.target.value)}
                  placeholder="Enter job responsibility"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
                <button
                  type="button"
                  onClick={() => removeArrayItem(idx, 'responsibilities')}
                  className="inline-flex items-center p-1.5 border border-transparent rounded-full text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={() => addArrayItem('responsibilities')}
            className="mt-3 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <svg className="mr-1.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            Add Responsibility
          </button>
        </div>
  
        {/* Requirements */}
        <div className="sm:col-span-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">Requirements</label>
          <div className="space-y-2">
            {jdForm.requirements.map((item, idx) => (
              <div key={idx} className="flex items-center space-x-2">
                <input
                  type="text"
                  value={item}
                  onChange={(e) => handleArrayChange(idx, 'requirements', e.target.value)}
                  placeholder="Enter job requirement"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
                <button
                  type="button"
                  onClick={() => removeArrayItem(idx, 'requirements')}
                  className="inline-flex items-center p-1.5 border border-transparent rounded-full text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                >
                  <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={() => addArrayItem('requirements')}
            className="mt-3 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <svg className="mr-1.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            Add Requirement
          </button>
        </div>
      </div>
  
      {/* Submit Buttons */}
      <div className="pt-6 border-t border-gray-200 flex justify-end space-x-3">
        <button
          type="button"
          className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Add Job Description
        </button>
      </div>
    </form>
  </div>
  )
}

export default AddJD